import React from "react";
import "./input-field.css";

interface RadioButtonFieldProps {
  label?: string;
  id: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  labelStyle?: string;
  radioStyle?: string;
}

export const RadioButtonField: React.FC<RadioButtonFieldProps> = ({
  label,
  id,
  name,
  value,
  checked,
  onChange,
  onBlur,
  labelStyle = "",
  radioStyle = "",
}) => {
  return (
    <div className="radio-button flex items-center">

      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        className={`css_radio`}
        />
      {/* <label htmlFor={id} className={`cursor-pointer ${radioStyle}`} /> */}
      {label && (
        <label
          htmlFor={id}
          className={`label leading-[100%] mb-[4px] ${labelStyle}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};
